<script>
import {
  liensandJudgementsMethods,
  orderReportMethods,
  userMethods,
  toasterMethods,
} from '@state/helpers'
import constant from '@constants/constant'
import reportOrderStatus from '@constants/reportOrderStatus'

export default {
  props: {
    customerId: {
      type: [Number, String],
      default: '',
    },
    customerUserId: {
      type: [Number, String],
      default: '',
    },
    productId: {
      type: [Number, String],
      default: '',
    },
  },
  data() {
    return {
      liensJudgementjsonData: '',
      errorLog: '',
      showSpinner: false,
      referenceNumber: '',
      firstName: '',
      middleName: '',
      lastName: '',
      streetAddress: '',
      state: '',
      stateCode: '',
      suffixCode: '',
      zip: '',
      maxbirtdate: '',
      dateofBirth: '',
      ssn: '',
      phoneNumber: '',
      cityName: '',
      driverLicenseNumber: '',
      driverLicenseState: '',
      drivingLicenseStateCode: '',
      drivingLicenseStateId: '',
      suffix: '',
    }
  },
  computed: {
    placeholders() {
      return {
        referenceno: 'Reference Number',
        firstName: 'First Name',
        middleName: 'Middle Name',
        lastName: 'Last Name',
        cityName: 'City Name',
        state: 'Select State',
        ssn: 'xxx-xx-xxxx',
        zip: 'xxxxx-xxxx',
        streetAddress: 'Street Address',
        phoneNumber: '(xxx) xxx-xxxx',
        legaldescription: 'Legal Description',
        driverLicenseNumber: "Driver's License Number",
        driverLicenseState: "Driver's License State",
        dateofBirth: 'MM/dd/yyyy',
      }
    },

    states() {
      return this.$_allStates
    },

    suffixes() {
      return this.$_suffixes
    },
  },
  mounted() {
    this.getMaxDateLimit()
  },

  methods: {
    ...toasterMethods,
    ...orderReportMethods,
    ...userMethods,
    ...liensandJudgementsMethods,
    // async getModal(message, type, method) {
    //   await this.$refs.msg.showAsync(message, type, 'Ok').then(() => {
    //     if (method) {
    //       method()
    //     }
    //   })
    // },
    getReportStatusId(key) {
      return reportOrderStatus[key]
    },
    buildLiensAndJudgement() {
      this.liensJudgementjsonData = JSON.stringify({
        UserId: this.currentUserId,
        Source: 'CPSS UI',
        SourceIp: '10.0.0.0',
        ReferenceNumber: this.referenceNumber,
        OrderForCustomer: this.customerId,
        OrderForUser: this.customerUserId,
        ProductId: this.productId,
        Borrower: {
          FirstName: this.firstName,
          MiddleName: this.middleName !== '' ? this.middleName : '',
          LastName: this.lastName,
          BorrowerType: 0,
          SSN: this.ssn,
          DateOfBirth: this.dateofBirth !== '' ? this.dateofBirth : null,
          Suffix: this.suffix !== '' ? this.suffix : '',
          SuffixValue: this.suffixCode !== '' ? this.suffixCode : '',
          Address: {
            AddressType: constant.currentAddress,
            Street: this.streetAddress,
            City: this.cityName,
            StateId: this.state,
            StateCode: this.stateCode,
            Zip: this.zip,
          },
          Contacts: {
            PhoneNumber: this.phoneNumber,
            PhoneType: 0,
          },
        },
        DrivingLicenseNumber: this.driverLicenseNumber,
        DrivingLicenseStateCode: this.driverLicenseStateCode,
        DrivingLicenseStateId: Number(this.drivingLicenseStateId),
        ResponseStatus: 0,
      }).replace(/^"(.*)"$/, '$1')
    },
    onReportSubmit(selectedValue) {
      this.getStateCode()
      let userInfo = this.$store.state.auth.currentUser.userInfo
      var isOrderReportComponentValid = false
      var isLiensJudgementReportComponentValid = false
      this.currentUserId = userInfo.userId
      var that = this
      this.$parent.$parent.$validator.validateAll().then((response) => {
        isOrderReportComponentValid = response
        this.$validator.validate().then((response) => {
          if (userInfo.roles.indexOf(constant.CreditAnalystOrLoanOfficer) !== -1) {
            isOrderReportComponentValid = response
            that.customerUserId = that.currentUserId
          }
          isLiensJudgementReportComponentValid = response
          if (
            isOrderReportComponentValid &&
            isLiensJudgementReportComponentValid
          ) {
            that.showSpinner = true
            that.getDrivingLicenseStateCode()
            that.getSuffixCode()
            that.buildLiensAndJudgement()
            that
              .fetchLiensAndJudgementReport({
                liensJudgementjsonData: that.liensJudgementjsonData,
              })
              .then((response) => {
                if (
                  response.data !== null &&
                  response.data.responseStatus === 'Completed' &&
                  response.data.reportByteArray !== undefined
                ) {
                  this.$router.push({
                    name: 'liendsandjudgementSummary',
                    params: { orderId: response.data.id }
                  })
                } else if (
                  this.getReportStatusId(response.data.responseStatus) ===
                  reportOrderStatus.Pending
                ) {
                  if (response.data.message !== null) {
                    this.setAlert({
                      title: 'Alert',
                      msg: response.data.message,
                      variant: constant.primaryMessagetype,
                    })
                  }
                  this.$emit('resetOrderReport')
                } else if (
                  response.data.message !== '' &&
                  response.data.message !== null &&
                  response.data.message !== undefined
                ) {
                  /* this.setAlert({
                    title: constant.imageHeaderSuccess,
                    msg: response.data.message,
                    variant: constant.successMessagetype,
                  }) */
                  this.$router.push({
                    name: 'liendsandjudgementSummary',
                    params: { orderId: response.data.id,
                              callOrigin: constant.origin.OrderReport
                            }
                  })
                } else {
                  this.setAlert({
                    title: constant.imageHeaderError,
                    msg: constant.errorMessage,
                    variant: constant.errorMessagetype,
                  })
                }
                this.showSpinner = false
              })
              .catch((error) => {
                this.showSpinner = false
                this.setAlert({
                  title: constant.imageHeaderError,
                  msg: constant.errorMessage,
                  variant: constant.errorMessagetype,
                })
                this.errorLog = error
              })
          }
        })
      })
    },
    getDrivingLicenseStateCode() {
      if (this.drivingLicenseStateId !== '') {
        this.driverLicenseStateCode = this.states.find(
          (x) => x.value === Number(this.drivingLicenseStateId)
        ).stateCode
      }
    },
    getStateCode() {
      if (this.state !== '') {
        this.stateCode = this.states.find(
          (x) => x.value === Number(this.state)
        ).stateCode
      }
    },

    getSuffixCode() {
      if (this.suffix !== '') {
        this.suffixCode = this.suffixes.find(
          (x) => x.value === Number(this.suffix)
        ).suffixCode
      }
    },
    getMaxDateLimit() {
      let today = new Date()
      let month =
        today.getMonth() + 1 <= 9
          ? '0' + (today.getMonth() + 1)
          : today.getMonth() + 1

      this.maxbirtdate = `${month}/${today.getDate()}/${today.getFullYear()}`
    },
  },
}
</script>

<template>
  <div>
    <BaseModalLayout ref="msg" hide-cancel modal-size="md" />
    <BaseSpinner v-if="showSpinner" />
    <b-row>
      <b-col md="3">
        <BaseEInputText
          id="referenceNumber"
          v-model="referenceNumber"
          v-validate="{ required: false, regex: /^[A-Za-z0-9-.'_, ]+$/ }"
          validattor="^[A-Za-z0-9-.'_, ]+$"
          data-vv-as="Reference No."
          type="text"
          maxlength="50"
          name="referenceNumber"
          label-content="Reference Number"
          :placeholder="placeholders.referenceno"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('referenceNumber') }} </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="3">
        <BaseEInputText
          id="firstName"
          v-model="firstName"
          v-validate="{
            required: true,
            regex: /^[A-Za-z0-9-.' ]+$/,
          }"
          validattor="^[A-Za-z0-9-.' ]+$"
          data-vv-as="First Name"
          type="text"
          name="firstName"
          maxlength="50"
          label-content="First Name"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('firstName'),
          }"
          :placeholder="placeholders.firstName"
          aria-describedby="firstName-live-feedback"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('firstName') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="middleName"
          v-model="middleName"
          v-validate="{ required: false, regex: /^[A-Za-z0-9-.' ]+$/ }"
          validattor="^[A-Za-z0-9-.' ]+$"
          data-vv-as="Middle Name"
          type="text"
          name="middleName"
          maxlength="50"
          label-content="Middle Name"
          :class="{
            input: true,
            'is-danger': errors.has('middleName'),
          }"
          :placeholder="placeholders.middleName"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('middleName') }} </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="lastName"
          v-model="lastName"
          v-validate="{
            required: true,
            regex: /^[A-Za-z0-9-.' ]+$/,
          }"
          validattor="^[A-Za-z0-9-.' ]+$"
          data-vv-as="Last Name"
          type="text"
          name="lastName"
          maxlength="50"
          label-content="Last Name"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('lastName'),
          }"
          :placeholder="placeholders.lastName"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('lastName') }} </div>
      </b-col>
    </b-row>
    <b-row> </b-row>
    <b-row>
      <b-col md="3">
        <BaseEInputText
          id="ssn"
          v-model="ssn"
          v-validate="{
            required: true,
            regex: /^\d{3}-?\d{2}-?\d{4}$/,
          }"
          validattor="[0-9]"
          maskker="(\d{3})(\d{2})(\d{4})"
          formatter="$1-$2-$3"
          type="text"
          maxlength="11"
          name="ssn"
          label-content="SSN"
          data-vv-as="SSN"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('ssn'),
          }"
          :placeholder="placeholders.ssn"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('ssn') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseELabel label="Suffix" />
        <BaseDropdown
          v-model="suffix"
          :field-id="suffix"
          :options="suffixes"
          name="sufix"
          :class="$style.dropOptionstyle"
        ></BaseDropdown>
      </b-col>
      <b-col md="3">
        <BaseELabel label="Date of Birth" />
        <BaseDate
          v-model="dateofBirth"
          type="date"
          :field-id="dateofBirth"
          name="dateofBirth"
          data-vv-as="Date of Birth"
          :max="maxbirtdate"
          :class="{
            input: true,
            'is-danger': errors.has('dateofBirth'),
          }"
        ></BaseDate>
        <div class="error">
          {{ errors.first('dateofBirth') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="phoneNumber"
          v-model="phoneNumber"
          v-validate="{
            required: false,
            regex: /^\(\d{3}\)\s*\d{3}(?:-|\s*)\d{4}$/,
          }"
          validattor="[0-9]"
          maskker="(\d{3})(\d{3})(\d{4})"
          formatter="($1) $2-$3"
          type="text"
          maxlength="14"
          name="phoneNumber"
          label-content="Phone Number"
          data-vv-as="Phone #"
          :class="{
            input: true,
            'is-danger': errors.has('phoneNumber'),
          }"
          :placeholder="placeholders.phoneNumber"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('phoneNumber') }}
        </div>
      </b-col>
    </b-row>
    <b-row class=" pb-3">
      <b-col md="3">
        <BaseEInputText
          id="driverLicenseNumber"
          v-model="driverLicenseNumber"
          v-validate="{
            required: drivingLicenseStateId === '' ? false : true,
            regex: /[A-Za-z0-9]/,
            min: 4,
          }"
          validattor="[A-Za-z0-9]"
          type="text"
          maxlength="19"
          name="driverLicenseNumber"
          label-content="Driver's License Number"
          data-vv-as="Driver's License Number"
          :mark-required="drivingLicenseStateId === '' ? false : true"
          :class="{
            input: true,
            'is-danger': errors.has('driverLicenseNumber'),
          }"
          :placeholder="placeholders.driverLicenseNumber"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('driverLicenseNumber') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseELabel
          :mark-required="driverLicenseNumber === '' ? false : true"
          label="Driver's License State"
        />
        <BaseDropdown
          v-model="drivingLicenseStateId"
          v-validate="{
            required: driverLicenseNumber === '' ? false : true,
          }"
          data-vv-as="Driver's License State"
          :field-id="drivingLicenseStateId"
          :options="states"
          class="mb-1"
          name="drivingLicenseStateId"
          :placeholder="placeholders.driverLicenseState"
          :class="$style.dropOptionstyle"
        ></BaseDropdown>
        <div class="error">
          {{ errors.first('drivingLicenseStateId') }}
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-3" align-v="center">
      <b-col md="auto">
        <div>
          <BaseELabel
            :class="$style.labelSubHeading"
            label="Residential Address"
          />
        </div>
      </b-col>
      <b-col class="border-bottom"></b-col>
    </b-row>
    <b-row class="border-bottom pb-3">
      <b-col md="5">
        <BaseEInputText
          id="streetAddress"
          v-model="streetAddress"
          v-validate="{ required: true, regex: /^[A-Za-z0-9-/#&%@'. ]+$/ }"
          validattor="^[A-Za-z0-9-/#&%@'. ]+$"
          type="text"
          name="streetAddress"
          maxlength="100"
          label-content="Street"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('street'),
          }"
          :placeholder="placeholders.streetAddress"
        ></BaseEInputText>
        <div v-show="errors.has('streetAddress')" class="error">
          Street is required
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="cityName"
          v-model="cityName"
          v-validate="{ required: true, regex: /^[A-Za-z-.' ]+$/ }"
          validattor="^[A-Za-z-.' ]+$"
          type="text"
          name="cityName"
          maxlength="20"
          label-content="City"
          mark-required
          data-vv-as="City Name"
          :class="{
            input: true,
            'is-danger': errors.has('cityName'),
          }"
          :placeholder="placeholders.cityName"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('cityName') }}
        </div>
      </b-col>
      <b-col md="2">
        <BaseELabel mark-required label="State" />
        <BaseDropdown
          v-model="state"
          v-validate="'required'"
          :field-id="state"
          :options="states"
          name="state"
          :placeholder="placeholders.state"
          :class="$style.dropOptionstyle"
        ></BaseDropdown>
        <div v-show="errors.has('state')" class="error">
          State is required
        </div>
      </b-col>
      <b-col md="2">
        <BaseEInputText
          id="zip"
          v-model="zip"
          v-validate="{ required: true, regex: /^[0-9]{5}(?:-[0-9]{4})?$/ }"
          validattor="[0-9]"
          maskker="(\d{5})(\d{4})"
          formatter="$1-$2"
          type="text"
          maxlength="10"
          name="zip"
          label-content="Zip"
          data-vv-as="Zip"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('zip'),
          }"
          :placeholder="placeholders.zip"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('zip') }} </div>
      </b-col>
    </b-row>
    <b-row class="my-3" align-h="center">
      <b-col>
        <BaseEButton size="md" @click="onReportSubmit">
          Submit
        </BaseEButton>
      </b-col>
    </b-row>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.labelSubHeading {
  margin-left: -2rem;
  font-size: $size-content-font;
  font-weight: 500;
  color: $color-text-gray;
}
.dropOptionstyle option {
  font-size: 16px;
}
</style>
